import React from "react";
import { Link } from "react-router-dom";

// =====================================================================================
// IMPORTANT: LEGAL PLACEHOLDER CONTENT
// This entire page contains placeholder text for the Terms of Service.
// It MUST be replaced with your actual, legally reviewed Terms of Service.
// Consult with a legal professional to ensure compliance.
// The effective date below is also a placeholder and needs to be accurate.
// =====================================================================================


const TermsOfServicePage = () => {
  const effectiveDate = "13th June 2025";
  const contactEmail = "support@practap.com";


  return (
    <main className="min-h-screen bg-slate-900 text-slate-200 py-12 px-4 sm:px-6 lg:px-8"> {/* Base text color improved */}
      <article className="max-w-3xl mx-auto bg-slate-800 p-6 sm:p-8 shadow-xl rounded-lg"> {/* article tag, adjusted padding */}
        <nav aria-label="Breadcrumb" className="mb-6">
          <Link
            to="/"
            className="text-sky-400 hover:text-sky-300 inline-block group" /* Contrast Fix */
          >
            <span aria-hidden="true" className="transition-transform duration-200 ease-in-out group-hover:-translate-x-1 inline-block">←</span> Back to Home
          </Link>
        </nav>
        <h1 className="text-3xl sm:text-4xl font-bold text-slate-50 mb-8 text-center"> {/* Contrast Fix */}
          Terms of Use for Practap
        </h1>
        <p className="mb-6 text-sm text-slate-300 text-center"> {/* Contrast Fix */}
          Effective Date: {effectiveDate}
        </p>

        {/* ===================================================================================== */}
        {/* BEGIN ACTUAL TERMS OF SERVICE CONTENT (CURRENTLY PLACEHOLDER)                     */}
        {/* Replace all content within this div with your finalized Terms of Service text.       */}
        {/* ===================================================================================== */}
        <div className="space-y-6 prose prose-slate prose-invert max-w-none
                        prose-headings:text-slate-100 prose-p:text-slate-200
                        prose-ul:text-slate-200 prose-li:marker:text-sky-400
                        prose-a:text-sky-400 hover:prose-a:text-sky-300"> {/* Tailwind typography for readability */}
          <p>
            Welcome to Practap — a platform designed to help you master communication and ace interviews using AI.
          </p>
          <p>By accessing or using our service, you agree to these terms.</p>

          <section aria-labelledby="description-of-service">
            <h2 id="description-of-service" className="text-2xl font-semibold text-slate-100 mb-3">
              1. Description of Service
            </h2>
            <p>Practap is a tool that:</p>
            <ul className="list-disc list-inside ml-4 mt-2 space-y-1">
              <li>Analyzes your uploaded CV</li>
              <li>Asks AI-generated interview questions</li>
              <li>Provides feedback based on your voice responses</li>
            </ul>
          </section>

          <section aria-labelledby="beta-disclaimer">
            <h2 id="beta-disclaimer" className="text-2xl font-semibold text-slate-100 mb-3">
              2. Beta Disclaimer
            </h2>
            <p>
              This platform is currently in beta. You may experience technical
              glitches or AI inaccuracies. Your use helps us improve the
              product.
            </p>
          </section>

          <section aria-labelledby="user-responsibilities">
            <h2 id="user-responsibilities" className="text-2xl font-semibold text-slate-100 mb-3">
              3. User Responsibilities
            </h2>
            <ul className="list-disc list-inside ml-4 space-y-1">
              <li>You must only upload your own CV.</li>
              <li>
                You must not use the platform for unlawful or misleading
                purposes.
              </li>
              <li>You agree to receive automated feedback from our AI.</li>
            </ul>
          </section>

          <section aria-labelledby="no-data-storage">
            <h2 id="no-data-storage" className="text-2xl font-semibold text-slate-100 mb-3">
              4. No Data Storage
            </h2>
            <p>
              We do not store user data. All input is processed in real-time and
              discarded after your session.
            </p>
          </section>

          <section aria-labelledby="intellectual-property">
            <h2 id="intellectual-property" className="text-2xl font-semibold text-slate-100 mb-3">
              5. Intellectual Property
            </h2>
            <p>
              All platform content, designs, and AI interactions are the
              intellectual property of Practap.
            </p>
          </section>

          <section aria-labelledby="limitation-of-liability">
            <h2 id="limitation-of-liability" className="text-2xl font-semibold text-slate-100 mb-3">
              6. Limitation of Liability
            </h2>
            <p>
              Practap provides AI-generated responses for mock interview
              purposes only. We are not responsible for any decisions or
              outcomes based on AI feedback.
            </p>
          </section>

          <hr className="my-8 border-slate-600" /> {/* Adjusted HR color */}

          <section aria-labelledby="contact-us" className="text-center">
            <h2 id="contact-us" className="text-2xl font-semibold text-slate-100 mb-3">
              📧 Contact Us
            </h2>
            <p>Have questions or concerns?</p>
            <p>
              Reach us at:{" "}
              <a
                href={`mailto:${contactEmail}`}
                className="text-sky-400 hover:text-sky-300" /* Contrast Fix */
              >
                {contactEmail}
              </a>
            </p>
          </section>
        </div>
        {/* ===================================================================================== */}
        {/* END ACTUAL TERMS OF SERVICE CONTENT                                                   */}
        {/* ===================================================================================== */}
        <div className="mt-10 pt-6 border-t border-slate-700 text-center"> {/* Added border top */}
          <p className="text-slate-400 text-sm"> {/* Contrast Fix */}
            Practap - Master your communication. Ace your interviews.
          </p>
        </div>
      </article>
    </main>
  );
};

export default TermsOfServicePage;
